// extracted by mini-css-extract-plugin
export default {"developIcon":"DevelopIcon_developIcon__6+rv8"};